import { marked } from "marked";

import { GlyphLoading } from "../components/glyphs";

export function InvoicePreview({ preview }) {
  if (!preview) {
    return <GlyphLoading/>;
  }

  return (
    <div className="invoice-preview">
      <h3>Invoice</h3>
      <div className="invoice-body" dangerouslySetInnerHTML={{ __html: marked.parse(preview.body || "", { async: false }) }}/>
    </div>
  );
}
